module.exports = __webpack_public_path__ + "assets/images/shop5.0f423ead.jpg";